<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  dialogTitle="Select Injects to Add"
  submitLabel="Add"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.catalog) {
    <div crucibleDialogContent>
      <app-inject-list
        [catalog]="data.catalog"
        [injectType]="data.injectType"
        [injectList]="data.injectList"
        [isContentDeveloper]="false"
        [loggedInUserId]="data.loggedInUserId"
        (selectedInjectIdList)="selectedInjectIdList=$event"
      ></app-inject-list>
    </div>
  }
</crucible-dialog>
